const _port = process.env.REACT_APP_PORT_BACKEND;
const _root = process.env.REACT_APP_IP_BACKEND;

export const uriList = (uri) =>
({
  tiposDocumento: `${_root}:${_port}/integracao/tiposDocumentoList`,
  tiposDocumentoShow: `${_root}:${_port}/integracao/tiposDocumentoShow`,
  tiposDocumentoDel: `${_root}:${_port}/integracao/tiposDocumentoDel`,
  tiposDocumentoAdd: `${_root}:${_port}/integracao/tiposDocumentoAdd`,

  documentos: `${_root}:${_port}/integracao/documentosList`,
  documentosShow: `${_root}:${_port}/integracao/documentosShow`,
  documentosDel: `${_root}:${_port}/integracao/documentosDel`,
  documentosAdd: `${_root}:${_port}/integracao/documentosAdd`,
  documentosTec: `${_root}:${_port}/integracao/documentosTec`,

  integracoes: `${_root}:${_port}/integracao/integracoesList`,
  getIntegracaoEmpresa: `${_root}:${_port}/integracao/getIntegracaoEmpresa`,
  integracoesShow: `${_root}:${_port}/integracao/integracoesShow`,
  integracoesDel: `${_root}:${_port}/integracao/integracoesDel`,
  integracoesAdd: `${_root}:${_port}/integracao/integracoesAdd`,
  integracoesSend: `${_root}:${_port}/integracao/sendDocuments`,
  integracoesAtivar: `${_root}:${_port}/integracao/ativarIntegracao`,

  requisitos: `${_root}:${_port}/integracao/requisitosList`,
  requisitosShow: `${_root}:${_port}/integracao/requisitosShow`,
  requisitosDel: `${_root}:${_port}/integracao/requisitosDel`,
  requisitosAdd: `${_root}:${_port}/integracao/requisitosAdd`,

  buscarColaboradores: `${_root}:${_port}/agenda/buscarcolaboradores`,
  buscarClientes: `${_root}:${_port}/agenda/buscarclientes`,
  buscarPessoas: `${_root}:${_port}/agenda/buscarPessoas`,

  selecionarEmpresas: `${_root}:${_port}/agenda/selecionarEmpresas`,

  //-- Totalizacoes
  listTotDocumentos: `${_root}:${_port}/integracaotot/documentos`,
  listTotIntegracoes: `${_root}:${_port}/integracaotot/integracoes`,

  //-- Outros
  listarDocumentos: `${_root}:${_port}/integracao/listDocuments`,
  listarDocumentosVencidos: `${_root}:${_port}/integracao/documentosListExpired`,
  listarDocumentosProxVecto: `${_root}:${_port}/integracao/documentosListCloseToExpire`,
  listIntegracoes: `${_root}:${_port}/integracao/listIntegracoes`,
  listarIntegracoesVencidas: `${_root}:${_port}/integracao/integracoesListExpired`,
  listarIntegracoesProxVecto: `${_root}:${_port}/integracao/integracoesListCloseToExpire`,
  gerarDossie: `${_root}:${_port}/integracao/generateDossie`,
  getZipUrls: `${_root}:${_port}/integracao/getZipUrls`,
  dropFile: `${_root}:${_port}/integracao/dropFile`,

  //-- Estoque
  contagensEstoque: `${_root}:${_port}/estoque/getcontagens`,
  novaContagem: `${_root}:${_port}/estoque/addContagem`,
  contagemItens: `${_root}:${_port}/estoque/getcontagensitens`,
  localizacoesEstoque: `${_root}:${_port}/estoque/getlocalizacoes`,
  produtosEstoque: `${_root}:${_port}/estoque/getprodutos`,
  addContagemItem: `${_root}:${_port}/estoque/addContagemItem`,
  updateContagemItemQuantidade: `${_root}:${_port}/estoque/updateContagemItemQuantidade`,
  delContagemItem: `${_root}:${_port}/estoque/delContagemItem`,
  estoqueProduto: `${_root}:${_port}/estoque/getproduto`,
  cancelarContagem: `${_root}:${_port}/estoque/cancelarContagem`,

  //Atendimento
  buscarAtendimento : `${_root}:${_port}/atendimentos/buscarAtendimentos`,
  updateosid : `${_root}:${_port}/atendimentos/update-osid`,
  updateapr : `${_root}:${_port}/atendimentos/update-apr`,
  sign      : `${_root}:${_port}/atendimentos/sign`,
  updatekm : `${_root}:${_port}/atendimentos/update-km`,
  getCertificate : `${_root}:${_port}/atendimentos/getCertificate`,
  updateCertificate : `${_root}:${_port}/atendimentos/updateCertificate`,

  //Dashboard Vendas
  dashboardDados: `${_root}:${_port}/dashboard/dados`,
  dashboardVendedores: `${_root}:${_port}/dashboard/vendedores`,
  dashboardClientes: `${_root}:${_port}/dashboard/clientes`,
}[uri] || "/");
